// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--162vL","arrow":"_93444fe79c--arrow--DpUq8","arrow-left":"_93444fe79c--arrow-left--3Bnbc","closer":"_93444fe79c--closer--33ovW"};